(function($){

	var slickSlider = function(){
		$('.hero-slider').slick({
			dots: true,
			arrows: false,
			autoplay: true,
			appendDots: $('.hero-slider'),
		});
		$('.featured-collection__list').slick({
			slidesToShow: 4,
			slidesToSroll: 2,
			nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right fa-2x"></i></button>',
			prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left fa-2x"></i></button>',
			responsive: [
				{
					breakpoint: 640,
					settings: {
						slidesToSroll: 1,
						slidesToShow: 2
					}
				},
				{
					breakpoint: 400,
					settings: {
						slidesToShow: 1,
						slidesToSroll: 1,
					}
				}
			]
		});
	};

	var toggleFilter = function() {
		$('.product-archive__filter p').on('click', function(e) {
			var filterList = $(this).parent();
			filterList.toggleClass('hidden');
		});
	};

	var videoEmbedHeight = function() {
		var videoHeight = $('.vp-player-layout').innerHeight();
		if( $('.player').length) {
			$('.player').css('max-height', videoHeight);
		}
	};

	$(document).ready(function(){
		slickSlider();
		toggleFilter();
		videoEmbedHeight();
	});

})(jQuery);